import type {
  VolunteerRegistrationPayload,
  VolunteerRegistrationResult,
} from '@sola/schema/dotcom/supporters/volunteers.ts';
import type {
  CompassionSundayBaseFormData,
  CompassionSundayRegistrationFormData,
  LeadChurchRequest,
  LeadEventRequest,
  SubscriptionRequest,
} from '@sola/schema/lib/skippy.ts';
import {
  httpPostWithStatus,
  isSuccessStatus,
} from '@sola/shared-utils/httpClient.ts';

const apiRouteBase = '/api';
const compassionSundayRouteBase = `${apiRouteBase}/compassion-sunday`;

/**
 * Send an email subscription request to the Skippy API
 */
export const submitSubscription = async (req: SubscriptionRequest) => {
  // TODO: do we need any CSRF protection here? How do we accomplish that with Next.js?
  const { statusCode } = await httpPostWithStatus(
    `${apiRouteBase}/subscriptions/`,
    req,
    { signRequest: true },
  );
  return statusCode >= 200 && statusCode < 300;
};

/**
 * * Send a Lead request to the Skippy API
 */
export const submitLeadChurchForm =
  (leadType: string, subscriptionCode: string) =>
  async (req: LeadChurchRequest) => {
    const { statusCode } = await httpPostWithStatus(
      `${apiRouteBase}/leads/`,
      {
        ...req,
        leadType,
        subscriptionCode,
      },
      { signRequest: true },
    );
    return statusCode >= 200 && statusCode < 300;
  };

/**
 * * Send a Event Lead request to the Skippy API
 */
export const submitLeadEventForm =
  (leadType: string) => async (req: LeadEventRequest) => {
    const { statusCode } = await httpPostWithStatus(
      `${apiRouteBase}/leads/event`,
      {
        ...req,
        leadType,
      },
      { signRequest: true },
    );
    return statusCode >= 200 && statusCode < 300;
  };

/**
 * Send a Compassion Sunday registration request to the Skippy API
 */
export const submitCompassionSundayRegistration = async (
  req: CompassionSundayRegistrationFormData,
) => {
  const { statusCode } = await httpPostWithStatus(
    `${compassionSundayRouteBase}/registration/`,
    req,
    { signRequest: true },
  );
  return statusCode >= 200 && statusCode < 300;
};

/**
 * Send a Compassion Sunday Plannding Guide request to the Skippy API
 */
export const submitCompassionSundayPlanningGuide = async (
  req: CompassionSundayBaseFormData,
) => {
  const { statusCode } = await httpPostWithStatus(
    `${compassionSundayRouteBase}/planning-guide/`,
    req,
    { signRequest: true },
  );
  return statusCode >= 200 && statusCode < 300;
};

/**
 * Register for volunteer slots at an event location.
 */
export const submitVolunteerRegistration = async (
  payload: VolunteerRegistrationPayload,
): Promise<VolunteerRegistrationResult> => {
  const { response, statusCode } = await httpPostWithStatus<{
    errors?: string[];
  }>(`${apiRouteBase}/volunteer/registrations`, payload, {
    signRequest: true,
  });

  if (isSuccessStatus(statusCode)) {
    return { success: true };
  }

  return {
    success: false,
    isConflict: statusCode === 410,
    errors: response?.errors,
  };
};
